import {executeQuery} from "@/data/repos/query"

export function getAutocompleteFn(fName: string) {
  return AutocompleteFunctions[fName]
}

export interface GenericAutocomplete {
  value: string,
  title: string
}

export interface Autocomplete {
  id: string,
  code: string,
  type: string,
  name: string
}

export const AutocompleteFunctions: {
  [key: string]: (loc: string, extra?: any) => Promise<any[]>,
} = {
  async locationAutocomplete(loc: string, exact: boolean = false): Promise<Autocomplete[]> {
    if (loc && String(loc).length) {
      let r = null
      if (exact) {
        r = await executeQuery("idr", "autocomplete_locationById", {id: loc})
      } else {
        r = await executeQuery("idr", "autocomplete_location", {partialText: "%" + loc + "%"})
      }
      if (r) {
        return r.map((v): Autocomplete => v as Autocomplete).slice(0, 15)
      } else {
        return []
      }
    }
    return []
  },
  async locationAutocompleteRegion(loc: string, exact: boolean = false): Promise<Autocomplete[]> {
    if (loc && String(loc).length) {
      let r = null
      if (exact) {
        r = await executeQuery("idr", "autocomplete_locationById", {id: loc})
      } else {
        r = await executeQuery("idr", "autocomplete_locationTypes", {types: ["g"], partialText: "%" + loc + "%"})
      }
      if (r) {
        return r.map((v): Autocomplete => v as Autocomplete).slice(0, 15)
      } else {
        return []
      }
    }
    return []
  },
  async surveyAutocomplete() {
    const r = await executeQuery(
      "idr",
      "appraisal.surveys",
      {}) || []
    return r.map((v): any => {
      return v as GenericAutocomplete
    })
  },
  async facetsAutocomplete(q: string, surveyId: string) {
    if (!(surveyId || "").length) return []
    const r = await executeQuery(
      "idr",
      "appraisal.survey_facets",
      {surveyId}) || []
    return r.map((v): any => {
      return v as GenericAutocomplete
    })
  },
  async categoryAutocomplete(q: string, facetId: string) {
    if (!(facetId || "").length) return []
    const r = await executeQuery(
      "idr",
      "appraisal.facet_categories",
      {facetId}) || []
    return r.map((v): any => {
      return v as GenericAutocomplete
    })
  },
  async elementsAutocomplete(q: string, categoryId: string) {
    if (!(categoryId || "").length) return []
    const r = await executeQuery(
      "idr",
      "appraisal.category_elements",
      {categoryId}) || []
    return r.map((v): any => {
      return v as GenericAutocomplete
    })
  },
  async subelementsAutocomplete(q: string, elementId: string) {
    if (!(elementId || "").length) return []
    const r = await executeQuery(
      "idr",
      "appraisal.element_subelements",
      {elementId}) || []
    return r.map((v): any => {
      return v as GenericAutocomplete
    })
  },
  async userIdAutocomplete(userId: string): Promise<GenericAutocomplete[]> {
    if (userId && userId.length) {
      const r = await executeQuery(
        "idr",
        "autocomplete_user",
        {partialText: "%" + userId + "%"})
      if (r) {
        return r.map((v): GenericAutocomplete => {
          return v as GenericAutocomplete
        }).slice(0, 15)
      } else {
        return [
          {value: "1", title: "Mr Bean"},
          {value: "2", title: "Hugh Laurie"},
          {value: "3", title: "Stephen Fry"},
        ]
      }
    }
    return []
  },
  async complianceElementList(): Promise<GenericAutocomplete[]> {
    return await executeQuery("idr", "complianceElementList", {})
  },
  async complianceElementIdAutocomplete(element: string, exact: boolean = false): Promise<GenericAutocomplete[]> {
    let r = null
    if (exact) {
      r = await executeQuery(
        "idr",
        "autocompleteComplianceElementId",
        {id: element})
    } else {
      r = await executeQuery(
        "idr",
        "autocompleteComplianceElementSearch",
        {partialText: "%" + element + "%"})
    }
    if (r) {
      return r.map((v): GenericAutocomplete => {
        return v as GenericAutocomplete
      })
    }
    return []
  },
  async hdCategoryIdAutocomplete(element: string, exact: boolean = false): Promise<GenericAutocomplete[]> {
    let r = null
    if (exact) {
      r = await executeQuery(
        "FMS_DB",
        "autocompleteCategoryId",
        {id: element})
    } else if (element) {
      r = await executeQuery(
        "FMS_DB",
        "autocompleteCategorySearch",
        {partialText: "%" + element + "%"})
    } else {
      r = await executeQuery(
        "FMS_DB",
        "autocompleteCategoryList",
        {})
    }
    if (r) {
      return r.map((v): GenericAutocomplete => {
        return v as GenericAutocomplete
      })
    }
    return []
  },
  async hdJobCategoryList(element: string, exact: boolean = false): Promise<GenericAutocomplete[]> {
    const r = await executeQuery(
      "FMS_DB",
      "autocompleteJobCategoryList",
      {})
    if (r) {
      return r.map((v): GenericAutocomplete => {
        return v as GenericAutocomplete
      })
    }
    return []
  },
  async auditCategoryAutocomplete(): Promise<GenericAutocomplete[]> {
    return (await executeQuery(
        "micad4-audit",
        "categories",
        {})
    ).map((v) => {
      return {title: v.localisedValue, value: v.categoryId}
    }) || []
  },
}
